module.exports = __webpack_public_path__ + "img/check_blue.ff1b9f35.svg";